import React, { useState } from "react";
import { withStyles } from '@material-ui/styles';

import { compose } from 'redux';

import NavigationTabContent from "../../../components/navigation_tab_content.js";

import TableView from "../../../../../base/table/table_view.js";

import pageStyles from "../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../base_info_page.js.jsx";

import { MemberModel } from "../../../../../models/companies/member_model.js";

const styles = theme => ({
  root: {
    position: "relative"
  }
});


const MembersInfoTabContent = (props) => {

  const { classes, company = {} } = props;
  const [members] = useState(company.members || []);

  return (
    <NavigationTabContent visible = { props.visible } >
      <div className = { classes.root } >
        <TableView columns = { MemberModel.listFields() }
                   items = { members } />
      </div>
    </NavigationTabContent>
  );
};

MembersInfoTabContent.defaultProps = {
}

export default compose(
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(MembersInfoTabContent);
